import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { getNetworkError } from 'common/utils';

import {
  getNotificationPreferences as getNotificationPreferencesApi,
  updateNotificationPreferences as updateNotificationPreferencesApi,
} from '../../api';

const GET_NOTIFICATION_PREFERENCES = 'notifications/GET_NOTIFICATION_PREFERENCES';
const SET_NOTIFICATION_PREFERENCES = 'notifications/SET_NOTIFICATION_PREFERENCES';
const UPDATE_NOTIFICATION_PREFERENCE = 'notifications/UPDATE_NOTIFICATION_PREFERENCE';

export const setNotificationPreferences = createAction(SET_NOTIFICATION_PREFERENCES);

export const getNotificationPreferences = createAsyncThunk(GET_NOTIFICATION_PREFERENCES, async () => {
  try {
    const preferences = await getNotificationPreferencesApi();
    return preferences;
  } catch (err) {
    Sentry.captureException(err);
    const errorMessage = getNetworkError(err);
    throw new Error(errorMessage);
  }
});

/**
 * Toggles a single notification type. Updates the UI optimistically and reverts
 * to the previous preferences if the request fails.
 */
export const updateNotificationPreference = createAsyncThunk(
  UPDATE_NOTIFICATION_PREFERENCE,
  async ({ type, enabled }, { dispatch, getState }) => {
    const { notifications } = getState();
    const previousPreferences = notifications.preferences;

    // Optimistic update.
    dispatch(setNotificationPreferences({ ...previousPreferences, [type]: enabled }));

    try {
      const preferences = await updateNotificationPreferencesApi({ [type]: enabled });
      return preferences;
    } catch (err) {
      // Revert on failure.
      dispatch(setNotificationPreferences(previousPreferences));
      Sentry.captureException(err);
      const errorMessage = getNetworkError(err);
      throw new Error(errorMessage);
    }
  },
);
